<template>
  <div>
    <template v-if="brokersStats === null">
      <div class="row">
        <div class="col-xs-12 text-center">
          loading data ...
          <div class="progress full m-t-xs" style="margin: 20px 0">
            <div class="progress-bar progress-bar-striped active progress-bar-info" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%">
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="brokersStats.length === 0">
      <div class="row">
        <div class="col-xs-12 text-center">
          No broker registered
        </div>
      </div>
    </template>
    <template v-else v-for="(chunk, key) in statsChunks">
      <div class="row" :key="'chunk-' + key">
        <div class="col-xs-12 col-md-6 col-lg-4 col-xl-3" v-for="(stats, key2) in chunk" :key="key2">
          <div class="panel">
            <div class="panel-heading">
              {{stats.lastName}} {{stats.firstName}}
            </div>
            <div class="panel-body">
              <idx-radar v-if="stats.radar" :stats="stats.radar" :height="300"></idx-radar>
            </div>
            <div class="panel-footer text-center font-bold" v-if="stats.oi_score !== null">
              Oi Score: {{stats.oi_score }} %
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import IdxRadar from '../charts/IdxRadar'
import _ from 'lodash'

export default {
  components: {IdxRadar},
  props: [],
  name: 'BrokersStatsIo',
  data () {
    return {
      brokersStats: null
    }
  },
  computed: {
    statsChunks () {
      return _.chunk(Object.values(this.brokersStats), 12)
    }
  },
  methods: {
    getResources: function () {
      this.axios.get('/stats/broker/ioStats').then((response) => {
        this.brokersStats = response.data

        this.brokersStats.sort((broker1, broker2) => {
          return broker2.oi_score - broker1.oi_score
        })
      }).catch((error) => {
      })
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stats/brokersStatsIo.vue